module.exports = __webpack_public_path__ + "img/youtube_navigation.ec075e17.png";